import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { PendenciasPanel } from '../components/financeiro/PendenciasPanel';
import { HonorarioAprovacaoCard } from '../components/financeiro/HonorarioAprovacaoCard';
import type { PendenciasDto, HonorarioDto } from '@prometeus/contracts';

export const Route = createFileRoute('/w/$workspaceId/financeiro/pendencias')({
  component: PendenciasPage,
});

function PendenciasPage() {
  const { workspaceId } = Route.useParams();

  const { data: pendencias, isLoading: loadingP } = useQuery<PendenciasDto>({
    queryKey: ['financeiro', workspaceId, 'pendencias'],
    queryFn: async () => {
      const res = await api.get('/financeiro/pendencias');
      return res.data.data ?? res.data;
    },
  });

  const { data: honorarios = [] } = useQuery<HonorarioDto[]>({
    queryKey: ['financeiro', workspaceId, 'honorarios'],
    queryFn: async () => {
      const res = await api.get('/financeiro/honorarios/pendentes');
      return res.data.data ?? res.data;
    },
  });

  return (
    <div className="space-y-5 rounded-2xl border-0 bg-[#FFFFFF] p-5 shadow-[0_0_15px_rgba(0,0,0,0.05)] outline-none ring-0 dark:bg-card dark:shadow-[0_0_15px_rgba(0,0,0,0.05)] sm:p-6 md:p-6">
      <div className="min-w-0">
        <h2 className="font-sans text-base font-normal tracking-normal text-[#06141B] dark:text-foreground">
          Pendências financeiras
        </h2>
        <p className="mt-1 max-w-2xl font-sans text-xs font-normal text-[#9BA8AB] dark:text-muted-foreground">
          Priorize títulos vencidos e acompanhe aprovações de honorários em aberto.
        </p>
      </div>

      {loadingP && (
        <div className="rounded-lg border border-border bg-card px-4 py-6 text-sm text-muted-foreground">
          Carregando pendências...
        </div>
      )}
      {pendencias && <PendenciasPanel pendencias={pendencias} workspaceId={workspaceId} />}

      {honorarios.length > 0 && (
        <div className="space-y-3 border-t border-black/[0.06] pt-5 dark:border-white/10">
          <h3 className="font-sans text-base font-normal tracking-normal text-[#06141B] dark:text-foreground">
            Honorários aguardando aprovação
          </h3>
          <div className="space-y-3">
            {honorarios.map((h) => (
              <HonorarioAprovacaoCard key={h.id} honorario={h} workspaceId={workspaceId} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
